import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete-loan-dialog',
  templateUrl: './confirm-delete-loan-dialog.component.html',
  styleUrls: ['./confirm-delete-loan-dialog.component.scss'],
})
export class ConfirmDeleteLoanDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ConfirmDeleteLoanDialogComponent>
  ) {}

  ngOnInit(): void {}
  confirm() {
    this.dialogRef.close(true);
  }
}
